import { FC } from "react"
import React,{useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { KTSVG } from "../../../smallnation/helpers"
import services from "../../modules/services/services"
import { Pagination } from "../../modules/utility/Pagination"
import moment from "moment";
import $ from 'jquery';
//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"


const UsersList: FC = () => {
      const intl = useIntl()

      const ITEMS_PER_PAGE = 10; // Per page show the data pagination
      const [totalItems, setTotalItems] = useState(0);
      const [totalpages, settotalPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(1);
   const companyarray = [];
      const [companyList, setCompanyList] = useState([]);
      const [userList, setUsersList] = useState([]);
     const Pagesize=10;
     var company='';
      const siteId = '2';                
      
  useEffect(() => 
      {         
        //getAdminProfilesList(ITEMS_PER_PAGE,'1','','');
        getAdminCompanyList();      
        filterUserList(ITEMS_PER_PAGE,'1');
        $('#company_list').hide();
      },[]);

      const searchList = () => {
        filterUserList(ITEMS_PER_PAGE,'1'); 
      } 

      function filterUserList(ITEMS_PER_PAGE,pageNumber){   
        var searchTxt:any = $('#search_input').val();
        //var encoded_queryval = encodeURIComponent(searchTxt);
        var encoded_queryval = searchTxt.trim();
        var usertype= $('#search_usertype').val();
        var company:any = $('#select_company').val();
            const requestObject={

              "siteId":"2",
              "userType":usertype,
              "searchTxt": encoded_queryval,
              "companyId" : company,
              "pageNumber":pageNumber,
              "pageSize":ITEMS_PER_PAGE
              }
         console.log(requestObject);
         var accessTokenIn=sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json',
                    'Authorization': "Bearer "+accessTokenIn 
                    //'Authorization': accessTokenIn 
                  },
          body: JSON.stringify(requestObject)
        };
        
        services.getAdminUserList(requestOptions).then((res) => 
        {
            console.log("#######################");
            console.log(res);
            if(res.content){
             // console.log(JSON.stringify(res));
             try{
              setTotalItems(res.totalElements);         
              settotalPages(Math.ceil(res.totalElements / ITEMS_PER_PAGE));            
              setCurrentPage(pageNumber);
              setUsersList(res.content);   
             }catch(ex){
              console.log("ex:"+ex);
             }
           
            }
            else{
              setUsersList([]); 
            }
              
        
        });
        }
      const handlePageChange2 = (offset,triggerevent) => {
        // alert(offset);
        filterUserList(ITEMS_PER_PAGE,offset);
      };
      const set_droplist = () => {
        var usertype= $('#search_usertype').val();
       if(usertype == 'company'){
           $('#company_list').show();   
          //$('#company_list').hide(); 
       }
       else{
           $('#company_list').hide();
           $('#select_company').val('');
       }
    }
    function getAdminCompanyList()
    {   
      var searchTxt = "";//$('#search_input').val();
      //var statuschk = 'published';
      var statuschk = 'published';
      var sortBy = 'name';
      var sortDir='asc';
      var itemsPerPage = '15000';
      var pageNumberV = '1';
      var siteIdv = '2';
      services.adminGetCompanyList(siteIdv,itemsPerPage,pageNumberV,searchTxt,statuschk,sortBy,sortDir).then((res) => 
      {
          if(res.data){
            var content = res.data.content;
            console.log("####################");
            console.log(JSON.stringify(content));
            content.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });

            setCompanyList(content);  
            companyarray.push(content.companyId); 
          }
           console.log(companyarray);
      
      });
  }
    
      type Props = {
        className: string
      }
      return (
        <>
          {/* <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Users List'})}</PageTitle> */}
          <PageTitle breadcrumbs={[]}>Users List</PageTitle>
         
        <div className={`card`}>
     
      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
        <table className=''>
            <thead>
              <tr className='fw-bolder text-muted pb-3 '>     
                <th  style={{minWidth:"250px"}}>
                <select className="form-select" aria-label="Default select example" id="search_usertype" name="search_usertype" onChange={set_droplist}> 
                    <option value="" selected>All Users</option>
                    <option value="siteAdmin">SiteAdmin</option>
                    <option value="schooladmin">SchoolAdmin</option>
                    <option value="schoolSuperAdmin">SchoolSuperAdmin</option>
                    <option value="company">Company</option>
                    <option value="profile">Jobseeker/Profile</option>
                    <option value="student">Student</option>
                  </select>
                </th>  
                <th  style={{minWidth:"250px"}} id="company_list">
                <select className="form-select" aria-label="Default select example" id="select_company" name="select_company"> 
                    <option value="" selected>All</option>
                    {
                        companyList.map((data, index) => (
                          <option value={data.companyId} >{data.name}</option>
                          ))}
                  </select>
                </th>          
                <th  style={{minWidth:"250px"}}><input type="text" id="search_input" name="search_input" className="form-control" placeholder="" onChange={searchList}/> </th>
                <th className='min-w-140px'> <button type="button" onClick={searchList} className="btn btn-primary" style={{maxWidth: "135px"}}> Search </button></th>
              </tr>
            </thead>
            </table>
          {/* begin::Table */}
          <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bolder text-muted'>
               {/* <th className='w-25px'>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value='1'
                      data-kt-check='true'
                      data-kt-check-target='.widget-13-check'
                    />
                  </div>
                </th> */}
                <th className='min-w-150px'>Name</th>
                <th className='min-w-140px'>Email</th>
                <th className='min-w-120px'>Phone</th>            
                <th className='min-w-120px'>User Type</th>   
                <th className='min-w-120px'>Company Name</th>
                {/* <th className='min-w-100px text-end'>Actions</th> */}
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>

            {	
	          userList.map((data, index) => (
              <tr>
              
                <td>
                  <a href='#' className='text-dark fw-bolder text-hover-primary fs-6'>
                  {(data.firstName=='' || data.firstName==null) ? '--' : data.firstName+' '+data.lastName}
                  </a>
                </td>
                <td>
                  <a href='#' className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>
                  {(data.email=='' || data.email==null) ? '--' : data.email}
                  </a>
                </td>
                <td>
                  <a href='#' className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>
                  {(data.phone=='' || data.phone==null) ? '--' : data.phone}
                  </a>
                </td>
              <td>
                  <a href='#' className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>
                  {(data.userType=='' || data.userType==null) ? '--' : data.userType}
                   </a>
                </td>
                <td>
                <a href='#' className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>
                {(data.companyName=='' || data.companyName==null) ? '--' : data.companyName}
                  </a>
                </td>
              
                <td className='text-end'>
                 
                  {/* <a
                    href="#"
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                  >
                    <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                  </a> */}
                
                </td>
              </tr>
              ))}
              
            </tbody>
            {/* end::Table body */}
          </table>

          <Pagination
                
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={handlePageChange2}

                />
         
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>


          
        </>
      )
    }
export {UsersList}